module.exports = __webpack_public_path__ + "static/media/spares1.f535407e.jpeg";